module.exports = __webpack_public_path__ + "static/media/checkmark.68e15803.gif";